export default {
  'areas.title': 'Gestionar Áreas',
};
